exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#preview[data-v-0754d5a3]{width:100%}.component-list[data-v-0754d5a3]{background:#eee;padding-top:30px;padding-bottom:30px}.v-list__tile[data-v-0754d5a3]:before{content:\"\";height:2px;width:8px;background:#777;margin-right:10px}.v-btn[data-v-0754d5a3]{z-index:15}.camera-btn[data-v-0754d5a3]{background-color:#006aff!important}", ""]);

// exports
